<form [formGroup]="filterForm" id="formFilter" (ngSubmit)="onSubmit()">
  <mat-radio-group  formControlName="option">
    <mat-list-item  *ngFor="let item of filter.options.ranges; let i = index">
      <mat-radio-button cdkFocusInitial color="accent" [value]="item.id">
        {{item.label | translate}}
      </mat-radio-button>
    </mat-list-item>
  </mat-radio-group>

  <mat-list-item >
    <div fxLayout="row" fxLayoutGap="10px">
      <mat-form-field >
        <mat-label translate>A2FILTER.INI_DATE</mat-label>
        <input matInput [matDatepicker]="iniPicker" formControlName="initDate" (focus)="setCustomDate()">
        <mat-datepicker-toggle matSuffix [for]="iniPicker" ></mat-datepicker-toggle>
        <mat-datepicker #iniPicker (opened)="setCustomDate()"></mat-datepicker>
      </mat-form-field>

      <mat-form-field>
        <mat-label translate> A2FILTER.END_DATE</mat-label>
        <input matInput [matDatepicker]="endPicker" formControlName="endDate" (focus)="setCustomDate()">
        <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
        <mat-datepicker #endPicker (opened)="setCustomDate()"></mat-datepicker>
      </mat-form-field>
    </div>
  </mat-list-item>
</form>
<!-- appearance="fill" -->
